import {
  Chevron,
  Disclaimer,
  Div,
  EditPenIcon,
  H5,
  Icon,
  MenuScheduleV2Dto,
  P,
  PlusIcon,
  Separator,
  SuccessToast,
  TrashIconRed,
  UpdateMenuScheduleV2Dto,
  deleteMenuSchedule,
  lightTheme,
  renderDayOfWeekString,
  updateMenuSchedule,
  reportError,
} from '@vgrubs/components';
import {
  MenuAvailabilityHourV2Response,
  MenuAvailabilityV2Response,
  MenuV2Response,
} from 'components/src/types/menu.types';
import { Provider } from 'components/src/types/shared.types';
import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router';
import { isMenuProviderDelivery } from '../../Menu';
import { Collapsible } from '../../MenyStyled';
import { AddEditAvailability } from './AddEditAvailability';
import { AddEditSchedule } from './AddEditSchedule';
import { DeleteAvailabilityModal } from './DeleteAvailabilityModal';
import { DeleteScheduleModal } from './DeleteScheduleModal';
import { convert24HourTo12Hour } from '../../../../helpers/time-helpers';

export const ModifierGroupComponent = ({
  item,
  setLoading,
  setMenu,
  menu,
  handleChangeShouldPublish,
  isPos,
}: {
  item: MenuAvailabilityV2Response;
  setLoading: Dispatch<SetStateAction<boolean>>;
  setMenu: Dispatch<SetStateAction<MenuV2Response | null>>;
  menu: MenuV2Response | null;
  handleChangeShouldPublish: (shouldPublish: boolean) => void;
  isPos: boolean;
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    if (ref?.current?.clientHeight) {
      setHeight(ref?.current?.clientHeight);
    }
  }, [menu]);

  const [expanded, setExpanded] = useState(false);

  const [addScheduleModal, setAddScheduleModal] =
    useState<MenuAvailabilityV2Response | null>(null);
  const [editAvailabilityModal, setEditAvailabilityModal] =
    useState<MenuAvailabilityV2Response | null>(null);

  const [deleteModalAvailability, setDeleteModalAvailability] = useState<
    number | null
  >(null);

  const { locationId, brandId, provider } = useParams() as {
    locationId: string;
    brandId: string;
    provider: Provider;
  };

  async function handleDeleteAvailability() {
    try {
      setLoading(true);
      const { data } = await deleteMenuSchedule(
        locationId,
        brandId,
        deleteModalAvailability as number
      );

      setMenu(data.data);

      SuccessToast(data.message);
      setDeleteModalAvailability(null);
      handleChangeShouldPublish(true);
    } catch (error) {
      reportError(error);
    } finally {
      setLoading(false);
    }
  }

  const isProviderDelivery = isMenuProviderDelivery(provider);

  return (
    <>
      <Div
        $box
        $p="16px 24px"
        $flex
        $alignCenter
        $between
        $mb="8"
        // $background={expanded && lightTheme.primary}
      >
        <Div
          $flex
          $alignCenter
          $gap="8px"
          onClick={() => setExpanded((prev) => !prev)}
          $width="100%"
          $pointer
        >
          <P
            $bold
            $m="0"
            //   $color={expanded && lightTheme.white}
          >
            {item.name}
          </P>
        </Div>
        <Div $flex $alignCenter $between $gap="20px">
          {!isPos && isProviderDelivery && (
            <Icon
              $shadow
              $pointer
              onClick={() => setEditAvailabilityModal(item)}
            >
              <EditPenIcon />
            </Icon>
          )}
          {!isPos && (
            <Icon
              $pointer
              onClick={() => setDeleteModalAvailability(Number(item.id))}
            >
              <TrashIconRed />
            </Icon>
          )}
          <Icon
            $pointer
            $rotate={expanded ? '360deg' : '180deg'}
            onClick={() => setExpanded((prev) => !prev)}
            // color={expanded ? lightTheme.white : lightTheme.darkGray}
          >
            <Chevron />
          </Icon>
        </Div>
      </Div>
      <Collapsible expanded={expanded} elementHeight={height}>
        <div ref={ref}>
          {item.hours.map((it, i) => {
            return (
              <ModifierComponent
                item={it}
                key={i}
                availability={item}
                menu={menu}
                setMenu={setMenu}
                setLoading={setLoading}
                setDeleteModalAvailability={setDeleteModalAvailability}
                handleChangeShouldPublish={handleChangeShouldPublish}
                isPos={isPos}
              />
            );
          })}
          {item.hours.length === 0 ? (
            <P $m="0" $center>
              No modifiers
            </P>
          ) : null}

          {!isPos && (
            <Div
              $flex
              $alignCenter
              $justifyEnd
              $gap="8px"
              $pointer
              onClick={() => setAddScheduleModal(item)}
            >
              <Icon>
                <PlusIcon />
              </Icon>

              <H5 $m="0" $color={lightTheme.primary}>
                Add Another Day
              </H5>
            </Div>
          )}
        </div>
      </Collapsible>

      <DeleteAvailabilityModal
        deleteModal={!!deleteModalAvailability}
        closeModal={() => {
          setDeleteModalAvailability(null);
        }}
        handleDeleteAvailability={handleDeleteAvailability}
      />

      <AddEditSchedule
        modalIsOpen={addScheduleModal}
        closeModal={() => {
          setAddScheduleModal(null);
        }}
        setLoading={setLoading}
        setMenu={setMenu}
      />

      <AddEditAvailability
        modalIsOpen={editAvailabilityModal}
        closeModal={() => {
          setEditAvailabilityModal(null);
        }}
        setLoading={setLoading}
        setMenu={setMenu}
        edit
        handleChangeShouldPublish={handleChangeShouldPublish}
      />
    </>
  );
};

export const ModifierComponent = ({
  item,
  availability,
  setLoading,
  setMenu,
  setDeleteModalAvailability,
  handleChangeShouldPublish,
  isPos,
}: {
  item: MenuAvailabilityHourV2Response;
  setLoading: Dispatch<SetStateAction<boolean>>;
  setMenu: Dispatch<SetStateAction<MenuV2Response | null>>;
  setDeleteModalAvailability: Dispatch<SetStateAction<number | null>>;
  menu: MenuV2Response | null;
  availability: MenuAvailabilityV2Response;
  handleChangeShouldPublish: (shouldPublish: boolean) => void;
  isPos: boolean;
}) => {
  const [addModal, setAddModal] = useState<MenuAvailabilityV2Response | null>(
    null
  );
  const [deleteModal, setDeleteModal] = useState<number | null>(null);

  const { provider, locationId, brandId } = useParams() as {
    provider: Provider;
    locationId: string;
    brandId: string;
  };

  const handleDeleteSchedule = async () => {
    const hrs = [] as MenuScheduleV2Dto[];

    availability.hours
      .filter((h) => h.id !== deleteModal)
      .forEach((element) =>
        hrs.push({
          day: element.day,
          startTime: element.startTime,
          endTime: element.endTime,
        })
      );

    const body: UpdateMenuScheduleV2Dto = {
      name: availability.name,
      hours: hrs,
    };

    try {
      setLoading(true);

      const { data } = await updateMenuSchedule(
        locationId,
        brandId,
        availability.id,
        body
      );
      setMenu(data.data);
      handleChangeShouldPublish(true);
    } catch (error) {
      reportError(error);
    } finally {
      setDeleteModal(null);
      setLoading(false);
    }
  };

  return (
    <>
      <Separator />
      <Div $p="16px 20px" $flex $between $alignCenter>
        <div>
          <Disclaimer $mb="4">{renderDayOfWeekString(item.day)}</Disclaimer>
          <P $m="0">
            {convert24HourTo12Hour(item.startTime)} -{' '}
            {convert24HourTo12Hour(item.endTime)}
          </P>
        </div>

        <Div $flex $alignCenter $between $gap="20px">
          {!isPos && (
            <Icon $pointer onClick={() => setAddModal(availability)}>
              <EditPenIcon />
            </Icon>
          )}
          {!isPos && (
            <Icon
              $pointer
              onClick={() => {
                if (availability.hours.length === 1) {
                  setDeleteModalAvailability(Number(availability.id));
                } else setDeleteModal(item.id as number);
              }}
            >
              <TrashIconRed />
            </Icon>
          )}
        </Div>
      </Div>

      <AddEditSchedule
        modalIsOpen={addModal}
        closeModal={() => {
          setAddModal(null);
        }}
        setLoading={setLoading}
        setMenu={setMenu}
        item={item}
        edit
      />

      <DeleteScheduleModal
        deleteModal={!!deleteModal}
        closeModal={() => {
          setDeleteModal(null);
        }}
        handleDeleteSchedule={handleDeleteSchedule}
      />
    </>
  );
};
